import { FC, memo, useCallback, useEffect } from 'react';
import { FileRejection, useDropzone } from 'react-dropzone';
import View from '@picsart/view/View';

import useBatchData from 'pages/Batch/sections/Context/useBatchData';
import { allowedUploadingTypes } from 'pages/Batch/configs';

interface IUploadDropzone {
  onDragActive: (active: boolean) => void;
  isDragDisabled: boolean;
}

const UploadDropzone: FC<IUploadDropzone> = ({ children, onDragActive, isDragDisabled }) => {
  const { data, acceptFiles } = useBatchData();

  const onDrop = useCallback((acceptedFiles: File[], rejectedFiles: FileRejection[]) => {
    if (!data.length) {
      return;
    }

    acceptFiles(acceptedFiles, rejectedFiles, true);
  }, [acceptFiles, data.length]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: allowedUploadingTypes,
    multiple: true,
  });

  useEffect(() => {
    onDragActive(isDragActive && !!data.length);
  }, [data.length, isDragActive, onDragActive]);

  const dragProps = !isDragDisabled ? getRootProps() : {};

  return (
    <View {...dragProps} height="100vh">
      {isDragActive && (
        <input {...getInputProps()} />
      )}
      {children}
    </View>
  );
};

export default memo(UploadDropzone) as FC<IUploadDropzone>;
